import { PARAMETER_VALUE, PARAMETER_LABEL } from 'constants/managementUI'
import { Unit, UnitGroup, UnitTree, Workflow } from 'types/common'
import { AssignmentDataItem } from './PlanNewJob.types'

export const formatList = (
  list = [] as (Workflow | Unit | UnitGroup | UnitTree)[],
  value = PARAMETER_VALUE,
  label = PARAMETER_LABEL,
) =>
  list.map(listItem => ({
    value: listItem[value as keyof typeof listItem],
    label: listItem[label as keyof typeof listItem],
  }))

export const formatAssignees = (assignmentList: AssignmentDataItem[]) =>
  assignmentList.map(({ site, tasks }) => ({
    site: site.id,
    tasks: tasks.map(task => ({
      id: task.id,
      assignedUserGroups: task.assignedUserGroups.map(({ id }) => id),
      assignedUsers: task.assignedUsers.map(({ id }) => id),
    })),
  }))
